import PropTypes from "prop-types";
import React from "react";
import LoadingOverlay from "react-loading-overlay";
import HashLoader from "react-spinners/HashLoader";

const LoadingSpinnerOverlay = ({ isActive, children }) => {
  return (
    <LoadingOverlay active={isActive} spinner={<HashLoader />}>
      {children}
    </LoadingOverlay>
  );
};

LoadingSpinnerOverlay.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

export default LoadingSpinnerOverlay;
